import React, { useCallback, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import { AppLayout } from "../components/appLayout";
import { AddCategoryModal } from "../components/AddCategoryModal";
import useApiClient from "../hooks/useApiClient";
import { confirmAction } from "../helpers/alertHelper";
import { CategoryWithCountsViewModel } from "../apiClient";

export const Categories = () => {
    const [categories, setCategories] = useState<CategoryWithCountsViewModel[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [deleting, setDeleting] = useState<boolean>(false);
    const [showAddModal, setShowAddModal] = useState<boolean>(false);
    const apiClient = useApiClient();

    const loadData = useCallback(async () => {
        if (!apiClient) return;
        setLoading(true);
        setCategories(await apiClient.categoriesAll());
        setLoading(false);
    }, [apiClient]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const deleteCategory = async (category: CategoryWithCountsViewModel) => {
        if (!await confirmAction()) return;
        setDeleting(true);
        await apiClient?.categoriesDELETE(category.name!);
        setDeleting(false);
        await loadData();
    }

    return (
        <AppLayout loading={loading}>
            <Container className="py-2">
                <Row className="align-items-center mb-3">
                    <Col>
                        <h1 className="mb-0">Categories ({categories.length})</h1>
                    </Col>
                    <Col xs="auto">
                        <Button onClick={() => setShowAddModal(true)}>
                            <FontAwesomeIcon icon={faPlus} className="me-2"/>
                            Add category
                        </Button>
                    </Col>
                </Row>

                <Card>
                    <Table hover responsive className="align-middle mb-0">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Bookmark count</th>
                            <th>Video count</th>
                            <th className="text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {categories.length === 0 && (
                            <tr>
                                <td colSpan={4} className="text-center text-body-secondary py-5">
                                    No categories yet.
                                </td>
                            </tr>
                        )}
                        {categories.map((category) => (
                            <tr key={category.name}>
                                <td className="fw-medium">{category.name}</td>
                                <td><Badge className="bg-secondary-subtle text-secondary-emphasis">{category.bookmarkCount}</Badge></td>
                                <td><Badge className="bg-secondary-subtle text-secondary-emphasis">{category.videoCount}</Badge></td>
                                <td className="text-end">
                                    <Button variant="outline-danger" size="sm" onClick={() => deleteCategory(category)} disabled={deleting}>
                                        <FontAwesomeIcon icon={faTrash} className="me-1"/>
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Card>
            </Container>

            {apiClient && (
                <AddCategoryModal
                    show={showAddModal}
                    onHide={() => setShowAddModal(false)}
                    apiClient={apiClient}
                    onSuccess={loadData}
                />
            )}
        </AppLayout>
    )
}